import { useEffect, useRef } from "react";

const twitterEmbed = `
<blockquote class="twitter-tweet"><p lang="es" dir="ltr">🤧🌼 En el <a href="https://x.com/hashtag/D%C3%ADaMundialDeLaAlergia?src=hash&amp;ref_src=twsrc%5Etfw">#DíaMundialDeLaAlergia</a> promovemos la prevención, la detección oportuna y la educación para cuidar la salud de la comunidad.<br><br>💙 En <a href="https://x.com/hashtag/M%C3%A1sMedTarapac%C3%A1?src=hash&amp;ref_src=twsrc%5Etfw">#MásMedTarapacá</a> trabajamos por una región con más especialistas médicos y una mejor atención.<a href="https://x.com/hashtag/MasMedicosParaTarapaca?src=hash&amp;ref_src=twsrc%5Etfw">#MasMedicosParaTarapaca</a> <a href="https://x.com/hashtag/Iquique?src=hash&amp;ref_src=twsrc%5Etfw">#Iquique</a> <a href="https://x.com/hashtag/Alergia?src=hash&amp;ref_src=twsrc%5Etfw">#Alergia</a> <a href="https://t.co/rR6pVRGCjW">pic.twitter.com/rR6pVRGCjW</a></p>&mdash; MásMed Tarapacá (@MasMedTarapaca) <a href="https://x.com/MasMedTarapaca/status/2075202315674341679?ref_src=twsrc%5Etfw">July 9, 2026</a></blockquote>
`;

declare global {
  interface Window {
    twttr?: {
      widgets: {
        load: (element?: HTMLElement | null) => void;
      };
    };
  }
}

export default function TwitterFeed() {
  const scriptLoaded = useRef(false);
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!scriptLoaded.current && !document.getElementById("twitter-wjs")) {
      const script = document.createElement("script");
      script.id = "twitter-wjs";
      script.async = true;
      script.src = "https://platform.x.com/widgets.js";
      script.charset = "utf-8";
      script.onload = () => {
        if (window.twttr && containerRef.current) {
          window.twttr.widgets.load(containerRef.current);
        }
      };
      document.body.appendChild(script);
      scriptLoaded.current = true;
    } else if (window.twttr && containerRef.current) {
      window.twttr.widgets.load(containerRef.current);
    }
  }, []);

  return (
    <div className="bg-white rounded-xl border border-gray-200 overflow-hidden h-full">
      {/* Encabezado */}
      <div className="flex items-center justify-between px-5 md:px-6 py-3 md:py-4 border-b border-gray-100">
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 rounded-full bg-masmed-gray-900 flex items-center justify-center text-white text-lg">
            <i className="ri-twitter-x-fill" />
          </div>
          <div>
            <span
              className="text-masmed-gray-800 text-base md:text-lg"
              style={{ fontFamily: "'Arial', 'Helvetica', sans-serif", fontWeight: 600 }}
            >
              X
            </span>
            <p className="text-masmed-gray-400 text-xs">@MasMedTarapaca</p>
          </div>
        </div>
        <a
          href="https://x.com/MasMedTarapaca"
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center gap-1.5 px-4 py-2 bg-masmed-gray-900 text-white text-sm rounded-md hover:opacity-90 transition-opacity duration-200 cursor-pointer whitespace-nowrap"
          style={{ fontFamily: "'Arial', 'Helvetica', sans-serif", fontWeight: 600 }}
        >
          <span className="w-4 h-4 flex items-center justify-center">
            <i className="ri-twitter-x-fill" />
          </span>
          Seguir
        </a>
      </div>

      {/* Post embebido */}
      <div className="p-4 md:p-5 bg-masmed-gray-50">
        <div ref={containerRef} className="flex justify-center">
          <div
            className="w-full max-w-[500px]"
            dangerouslySetInnerHTML={{ __html: twitterEmbed }}
          />
        </div>
      </div>
    </div>
  );
}